import React from 'react';

import FooterContainer from 'containers/footer/FooterContainer';
import { default as Navbar } from 'containers/navbar/NavbarContainer';

import beach_2 from 'assets/img/stock/mauritius/beach_2.jpg'

export default () =>
    <div className="fullheight">
        <Navbar className="dark_start" />

        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div
                        className="col-md-12 bordered_block grey_border image_bck m-t-120 p-t-30"
                        data-image={beach_2}
                    >
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 wow fadeInLeft">
                                    <span className="great_title">
                                        MAURITIUS
                                    </span>
                                    {/* <span className="great_subtitle great_subtitle_big">
                                        Thailand
                                    </span> */}
                                    <br />
                                    <span className="into_txt">
                                        Mauritius is one of the best
                                        destinations in the Indian Ocean. It is
                                        exotic, tropical, and simply beautiful!
                                        It is adorned with endless miles of
                                        dazzling, white soft sand and blue water
                                        beaches naturally protected by a coral
                                        reef, making viewing of marine life a
                                        brilliant spectacle. The warm pleasant
                                        tropical temperatures, an interesting
                                        fusion of African, Indian, French and
                                        English cultures, and stunning
                                        landscapes makes it irresistible. This
                                        island is best for singles seeking
                                        adventure, couples on honeymoon or
                                        families looking for fun and a worry
                                        free relaxation.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*  */}
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h2>Things to do in Mauritius</h2>

                        <h3>Dolphin Cruises</h3>
                        <p className="dark-text">
                            This is the best experience ever! You will have an
                            opportunity experience an early morning (dawn)
                            cruise with a refreshing swim with dolphins in their
                            natural habitat. You will get to know these
                            beautiful gentle animals untamed by any human
                            influence! The best place for such an unforgettable
                            adventure is the one and only Tamarin Bay or Flic en
                            Fac beaches.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>SNORKELING at the BLUE BAY BEACH</h3>
                        <p className="dark-text">
                            The protected marine park, a boat ride from this
                            public beach offers the best snorkeling spot. Here,
                            you will come face to face with schools of
                            kaleidoscopically colored fish and corals. Take it a
                            notch higher by booking a guided tour that will take
                            you into Tourin the lesser treaded islands in the
                            southern part of the lagoon for a private session.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>VISIT THE BOTANICAL GARDENS</h3>
                        <p className="dark-text">
                            If visiting a botanical garden is your thing, this
                            is the place to be! The Pamplemousses also known as
                            "Sir Seewoosagur Ramgoolam Botanical Garden", is the
                            oldest botanical garden in the Southern Hemisphere.
                            It is adorned with animals like deer, turtle or
                            tortoise, and a variety of plants including giant
                            water lilies.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>Charamel village</h3>
                        <p className="dark-text">
                            Have you ever seen sand dunes naturally laid into a
                            spectacle of different colors? Charamel village
                            offers you this unique opportunity. Chamarel is a
                            small village in Mauritius, one of the only places
                            on earth where you can see such vibrant colored sand
                            ranging from blue, violet, yellow, red, brown,
                            purple, green. The vibrant colors are more vivid at
                            sunrise. The sand's vibrant colors is a result of
                            basaltic lava changing to clay, having been
                            subjected to earth's weathering conditions. This
                            colored sand, collected together in tall skinny
                            bottles make a remarkable souvenir. Chamarel village
                            also has a waterfall for an added enjoyment and
                            photography.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>THE COASTLINE CRUISE</h3>
                        <p className="dark-text">
                            Mauritius is adorned with endless lagoons that lace
                            most of its coastline. It is best to take in some of
                            this coastline’s beauty via a sunset cruise. This is
                            done best via the East Coast tours. This tour
                            provides a 2-hour Catamaran cruise in which snacks
                            and drinks are served, while a live band is playing.
                            The cruise vessel departs from Pointe Jerome, near
                            Blue Bay, around most of the islands including the
                            Ile aux Aigrettes Island and the Ile de la Pase.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>EXPLORE VOLCANOES</h3>
                        <p className="dark-text">
                            Mauritius has some of the oldest and impressive
                            volcanoes. The four main volcanoes are Trou Kanaka,
                            Bassin Blanc, Grand Bassin and Trou aux Cerfs. Trou
                            aux Cerfs is dormant and has a crater measuring 350
                            meters wide and affords a 360 degrees view of the
                            Curepipe town below, along with its magnificent
                            coastal lines.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>TAMARIND FALLS</h3>
                        <p className="dark-text">
                            If you are a fan of the outdoors, the Tamarind falls
                            is the place to go. Here you will have the
                            opportunity to engage in activities such as
                            canyoneering, hiking, zip lining, swimming as well
                            as marveling at the Tamarind falls as it cascades
                            down among a dense vegetation, a beauty in itself.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>The Mansion (Eureka La Maison Creole)</h3>
                        <p className="dark-text">
                            This is an antique building that is partly a museum
                            and partly a restaurant. Famous for the restaurant
                            part is the dry beef curry every visitor should
                            sample, it is simple delicious. The museum comprises
                            of the 1830s grand colonial home, intact and well
                            preserved with its original furniture. Hover around
                            the deck or simply enjoy a snack while being dazzled
                            by the beautiful and fragranced gardens below. This
                            place is simply meant for honeymooners, I can’t say
                            anymore other than come and see for yourself. It
                            will also satisfy people seeking adventure and a
                            historic perspective of our past.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>WALK UNDERWATER </h3>
                        <p className="dark-text">
                            Have you ever walked under water? You can certainly
                            do this in Mauritius. This is a guided tour and you
                            do not need to know how to swim to experience this.
                            You will be transported on a motorboat to the
                            walking spot. There, you will receive safety
                            briefings before strapping on your weights and
                            helmet. Underwater you will be able to marvel at
                            some beautiful corals, heavenly decorated with all
                            kinds of fish and marine life.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>CASINOS</h3>
                        <p className="dark-text">
                            There is more than 20, both private and public
                            casinos to satisfy your passion. The most luxurious
                            casinos are located in upscale hotels such as Le
                            Saint Geran which require formal dress code. There
                            is also private but casual casinos in main towns.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>DRIVE AROUND THE EAST COAST</h3>
                        <p>
                            Just drive around the coastline and admire locals’s
                            way of life. Stop at different places such as
                            old-fashioned towns of Queen Victoria and Petit
                            Julie and mingle with the locals, or stop your car
                            and go for a swim along the coast.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>BOIS CHERI TEA PLANTATION</h3>
                        <p className="dark-text">
                            This is a 250-hectare tea plantation which is also a
                            museum. The best tour is early in the morning when
                            you get to watch or participate picking tea along
                            with tea pickers as they begin their day. The
                            restaurant at the plantation offers delicious lunch:
                            why not complete a tour with one of their amazing
                            Creole dishes.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>GANGA TALAO (Grand Bassin Volcanic Crater)</h3>
                        <p className="dark-text">
                            As much as it is a natural attraction, this
                            crater-lake will give you a glimpse into the Hindi
                            culture. It is considered the most sacred place for
                            Hindi religion in the whole of Mauritius. The local
                            people believe the water in the lake came from the
                            Ganges River in India and thus sacred. There is a
                            temple with a giant 33 meter (108 ft) statue of
                            Indian Lord Shiva which also serves as a tourist
                            attraction in addition to being a sacred worship
                            center for the locals. This is the second largest
                            statue in the world. If you are lucky to visit
                            during the Shivratri festival, you could actual swim
                            in the lake and this is considered special.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>The Islands</h3>
                        <h4>Ile Aux Aigrettes</h4>
                        <p className="dark-text">
                            This island is uninhabited and has been free from
                            human influence for a long time. However daily
                            visits will enable you to see the birds rescued from
                            extinction such as the Pink Pigeon. You will also
                            see the giant tortoise, famous in Mauritius. This
                            secluded island also hosts most of the tropical and
                            exotic plants and animals in the Indian Ocean
                            Islands. The island was declared a natural reserve
                            in 1965.
                        </p>
                        <h4> Le Caudan Waterfront</h4>
                        <p className="dark-text">
                            This is the shoppers’ island located on the
                            waterfront facing harbor. Here you will find upscale
                            shopping malls with over 170 boutiques and shops
                            such as Gucci, upscale cafes as well as a casino.
                            The most notable here is the upscale ostentaneous
                            and perhaps the biggest Spas in the whole of the
                            Indian Ocean islands. This is one of the treats
                            everyone visiting should experience. The Outrigger
                            Resort & Spa with a Moroccan theme has treatment
                            rooms that are joined to Koi-carp ponds. This is a
                            special treat and you would not want to miss out on
                            this!
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 m-b-60 m-t-20">
                        <h3>MARADIVA VILLAS RESORT & SPA</h3>
                        <p className="dark-text">
                            It is worthwhile to mention this unforgettable place
                            here. The resort and Spa will truly give you an
                            Indian exotic life experience. This place takes
                            pride in its Award-winning holistic spa. There is an
                            impressive kids club with a shallow wading pool,
                            making it the best suitable choice for families. The
                            resort has 65 opulent villas each with a private
                            pool and beautiful gardens. The most unique aspect
                            here is the secluded open-air rain shower. This is
                            very different and leaves you wowed! At your
                            request, you can have 24 hour butler service. If
                            travelling with a large group or family, you can
                            request villas with interconnecting suites.
                        </p>
                    </div>
                </div>
                {/*  */}
            </div>
        </section>
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/details/mauritius/MauritiusDetails.jsx